export class Version {
	private static GIT_TAG : string =  'v1.07';
	private static GIT_BRANCH : string =  'master';
	private static GIT_COMMIT : string =  '443eb7e';
	private static GIT_BUILD : string =  '1490';
	public static toString() : string { return Version.GIT_TAG + ' (' + Version.GIT_COMMIT + ')'; }
}
